import { axiosApiClient } from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/analytics";

class AnalyticsService {
  getDetailedSiteAnalytics = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/site/detailed`);

      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while fetching detailed site analytics."
      );
    }
  };
}

const analyticsService = new AnalyticsService();
export default analyticsService;
